import { PatientDetailTreatmentCardUtils } from '../../../utils/PatientDetailTreatmentCard.utils';
import { PatientDetailCard } from './PatientDetailCard';
import { DandyMouthDisplay } from '@orthly/dentin';
import type { FragmentType } from '@orthly/graphql-inline-react';
import { getFragmentData, graphql } from '@orthly/graphql-inline-react';
import { styled } from '@orthly/ui-primitives';
import React from 'react';

const DandyMouthContainer = styled('div')({
    maxWidth: 438,
    margin: '16px auto 0px auto',
});

const PatientDetailTreatmentCardScan_Fragment = graphql(`
    fragment PatientDetailTreatmentCardScan_Fragment on PatientScan {
        items {
            ...OrderItemV2DTO
        }
    }
`);

interface PatientDetailTreatmentCardProps {
    selectedScanIndex: number | null;
    scanFragments: readonly FragmentType<typeof PatientDetailTreatmentCardScan_Fragment>[];
}

const useHighlightedItems = (args: PatientDetailTreatmentCardProps) => {
    const { selectedScanIndex, scanFragments } = args;

    return React.useMemo(() => {
        if (selectedScanIndex === null) {
            return { items: [], bridges: [] };
        }

        const selectedScan = getFragmentData(PatientDetailTreatmentCardScan_Fragment, scanFragments[selectedScanIndex]);

        return PatientDetailTreatmentCardUtils.getPatientDetailHighlightedItems(selectedScan);
    }, [selectedScanIndex, scanFragments]);
};

export const PatientDetailTreatmentCard: React.VFC<PatientDetailTreatmentCardProps> = props => {
    const { selectedScanIndex, scanFragments } = props;

    const highlightedItems = useHighlightedItems({ selectedScanIndex, scanFragments });

    return (
        <PatientDetailCard gridArea={'treatment'} title={'Treatment'}>
            <DandyMouthContainer>
                <DandyMouthDisplay
                    items={highlightedItems.items}
                    bridges={highlightedItems.bridges}
                    verticalLayout={false}
                    animate={false}
                />
            </DandyMouthContainer>
        </PatientDetailCard>
    );
};
